module.exports = __webpack_public_path__ + "img/wenhao.81ed1491.png";